import { createTheme } from '@uiw/codemirror-themes';
import { tags as t } from '@lezer/highlight';

export const oneDarkTheme = createTheme({
    theme: 'dark',
    settings: {
        background: '#1e2227',
        foreground: '#abb2bf',
        caret: '#528bff',
        selection: '#3e4451',
        selectionMatch: '#3e4451',
        lineHighlight: 'rgba(255, 255, 255, 0.03)',
        gutterBackground: '#1e2227',
        gutterForeground: '#5c6370',
    },
    styles: [
        { tag: t.comment, color: '#5c6370', fontStyle: 'italic' },
        { tag: t.variableName, color: '#e06c75' },
        { tag: [t.string, t.special(t.brace)], color: '#98c379' },
        { tag: t.number, color: '#d19a66' },
        { tag: t.bool, color: '#c678dd' },
        { tag: t.null, color: '#56b6c2' },
        { tag: t.keyword, color: '#c678dd' },
        { tag: t.operator, color: '#56b6c2' },
        { tag: t.className, color: '#e5c07b' },
        { tag: t.definition(t.typeName), color: '#e5c07b' },
        { tag: t.typeName, color: '#e5c07b' },
        { tag: t.angleBracket, color: '#5c6370' },
        { tag: t.tagName, color: '#e06c75' },
        { tag: t.attributeName, color: '#d19a66' },
        { tag: t.propertyName, color: '#61afef' },
    ],
});
